import { createSelector } from 'reselect';
import PredesComplianceMessageMappingErrorsErrorMessagesColumns
  from '../../containers/PredesComplianceMessageMappingErrorsErrorMessagesColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MESSAGE_MAPPING_ERRORS_MESSAGES.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMessageMappingErrorsErrorMessagesColumns);
